module.exports = __webpack_public_path__ + "static/bojan-eed61c3638631361b98c235783910b9f.jpg";